import React from 'react';
import HousingCharts from './charts/HousingCharts';
import RankBox from './RankBox';
import { permitsPerTenK, housingStarts12Month } from './api/rankBoxes';

const HousingView = () => {
  return (
    <div className="container mx-auto px-4">
      <div className="flex flex-wrap justify-center">
        <RankBox
          title="Permits Per 10K Population Rank"
          value={permitsPerTenK?.value || 0}
          type="rank"
          rank={permitsPerTenK?.rank}
          trend={permitsPerTenK?.trend}
        />
        <RankBox
          title="Housing Permits past 12 months"
          value={housingStarts12Month?.value || 0}
          type="number"
          rank={housingStarts12Month?.rank}
          trend={housingStarts12Month?.trend}
        />
      </div>
      <div className="bg-white rounded-lg shadow p-6 mt-4">
        <HousingCharts />
      </div>
    </div>
  );
};

export default HousingView;